module.exports = "<notification-bar></notification-bar>\n<app-spinner></app-spinner>\n<div class=\"wrapper clearfix\">\n\t<router-outlet></router-outlet>\n  <nuc-terms #terms> </nuc-terms>\n</div>\n<app-footer *ngIf=\"!isSite\"></app-footer>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 566
// module chunks = 9